/* eslint-disable camelcase */
export type TAxonUserData = {
  user_id?: string
  email?: string
}

// AppLovin (axon) hashes plaintext, lowercased emails for us -
// https://support.applovin.com/en/growth/promoting-your-websites/track-and-optimize/events-and-objects#the-user-data-object
export const getAxonUserData = (
  userId?: string | null,
  email?: string | null,
): TAxonUserData => {
  const normalizedEmail = email?.trim().toLowerCase() || undefined

  return {
    ...(userId ? { user_id: userId } : {}),
    ...(normalizedEmail ? { email: normalizedEmail } : {}),
  }
}
